import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import {Box, Typography,Divider} from '@mui/material';
import MonthlyCostStatusFinancialSummary from './MonthlyCostStatusFinancialSummary';
import { fetchMonthlyCostStatusSubmissionData } from '../../Containers/api';
import { toast } from "react-hot-toast";
import { toastStyle } from "../../Containers/continerUtilityFunctions";
import '../../static/monthly-cost-status-styles.css';

const HTMLViewer = ({ htmlString }) => {
	return (
		<div
			style={{ fontSize: 12 }}
			className="monthly-cost-status-html-viewer"
			dangerouslySetInnerHTML={{ __html: htmlString }}
			onClick={(e) => {
				// Allow links to work normally
				if (e.target.tagName === 'A' || e.target.closest('a')) {
					return;
				}
				e.preventDefault();
				e.stopPropagation();
			}}
		/>
	);
};


export default function MonthlyCostStatusSnapshotViewer({projectId, mode, month}) {
	const [monthlyCostStatusData, setMonthlyCostStatusData] = useState(null);
	useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await fetchMonthlyCostStatusSubmissionData(projectId, month);
				setMonthlyCostStatusData(data);
			} catch (error) {
				console.error("Error fetching monthly cost status data:", error);
				toast.error(error.message || "An unexpected error occurred.", toastStyle());
			}
		};
		fetchData();
	}, [mode, month, projectId]);

	const fields = [
		{
			id: 'financial_summary',
			label: 'Financial Summary Comments',
		},
		{
			id: 'billing_summary',
			label: 'Billing Summary Comments',
		},
		{
			id: 'permitting_and_design',
			label: 'Summary of Permitting/Design Progress',
		},
		{
			id: 'buyout_progress',
			label: 'Buyout Progress',
		},
		{
			id: 'construction_progress',
			label: 'Construction/Schedule Progress',
		},
		{
			id: 'project_risk',
			label: 'Project Risk',
		},
		{
			id: 'raving_fans',
			label: 'Raving Fans',
		},
		{
			id: 'additional_comments',
			label: 'Additional Comments',
		},
	];
	
	let tableHeaders = ['','Current','MOM Change ($)','MOM Change (%)'];

	const tableData = monthlyCostStatusData?.cost_status_data?.financial_summary_table
	if (!monthlyCostStatusData){
		return (
			<Box sx={{ width: '100%' }}>
				<Typography variant="subtitle1">Loading...</Typography>
			</Box>
		);
	} else if (monthlyCostStatusData?.selected_snapshot === null) {
		return (
			<Box sx={{ width: '100%' }}>
				<Typography variant="subtitle1">No Monthly Cost Status Data available for this month.</Typography>
			</Box>
		);
	}

	return (
		<Box sx={{ width: '100%'}}>
			<Typography variant="subtitle1" sx={{ mb: 2 }}>
				This Cost Status was saved/submitted on {new Date(monthlyCostStatusData?.last_updated_at).toLocaleString('en-US') || 'N/A'} by {monthlyCostStatusData?.last_updated_by || 'N/A'}
			</Typography>
			<Divider sx={{ my: 1 }} />
			{/* <MonthlyCostStatusFinancialSummary tableHeaders={tableHeaders} tableData={tableData} />
			{fields.map((field, idx) => (
				<Box key={field.id}>
					<Typography variant="subtitle1">{`${idx + 1}. ${field.label}`}</Typography>
					<HTMLViewer htmlString={monthlyCostStatusData?.cost_status_data?.[field.id] === "" ? "<p>---</p>" : monthlyCostStatusData?.cost_status_data?.[field.id]} />
					<Divider sx={{ my: 1 }} />
					<br />
				</Box>
			))}
			{monthlyCostStatusData?.files.map((file, index) => (
				<Box key={index} sx={{ mb: 2 }} display="flex">
					<Typography variant="subtitle1">Attached File {index + 1}:&ensp;
					<a href={file.url} target="_blank" rel="noopener noreferrer">
						{file.name}
					</a>
					</Typography>
					<br />
				</Box>				
			))} */}
			{monthlyCostStatusData?.email ? (
				<HTMLViewer htmlString={monthlyCostStatusData?.email.replace('ul li::before { content: "2"; }','')} />
			) : (
				<Typography variant="subtitle1">No HTML content available.</Typography>
			)}
		</Box>
	);
}